import React from "react"
import { FormGroup, ControlLabel, FormControl, Panel, Glyphicon } from "react-bootstrap"
import Spinner from "react-spinkit"
import md5 from "md5"
import _ from "underscore-node"
import { Log } from "../lib/logger"

class LoadImages extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            isLoadingFiles: false
        }
    }
    handleFileUploadChange = ({ target: { files } }) => {
        if(!files)
            return

        this.setState({isLoadingFiles: true})
        Log().time(`Loading ${files.length} files timed`)

        const alreadyExistingImageMd5s = _.map(this.props.sourceFiles, sf => sf.imageMd5)
        let numberOfFilesLeftToLoad = files.length

        _.chain(files)
            .each(f => {
                let reader = new FileReader()
                let file = f

                reader.onloadend = () => {
                    const filePreviewUrl = reader.result
                    const imageMd5 = md5(filePreviewUrl)

                    if(alreadyExistingImageMd5s.indexOf(imageMd5) !== -1)
                        return

                    const image = new window.Image()
                    image.src = filePreviewUrl
                    image.onload = () => {
                        this.props.onFileLoaded({file, filePreviewUrl, imageMd5, image, width: image.width, height: image.height })

                        numberOfFilesLeftToLoad--
                        if(numberOfFilesLeftToLoad === 0) {
                            this.setState({isLoadingFiles: false})
                            if(files.length === 1)
                                this.props.onSingleFileLoaded()
                            Log().timeEnd(`Loading ${files.length} files timed`)
                        }
                    }
                }

                reader.readAsDataURL(file)
            })
    }

    render() {

        return (
            <Panel>
                <Panel.Heading>
                    Find or Drag and drop images or photos you want to make crops from
                    {this.state.isLoadingFiles ? <Spinner name="wordpress" color="#398439" overrideSpinnerClassName={"float-left-in-heading"} /> : ""}
                    {this.props.nudgeFromLoadImages ? <Glyphicon glyph="arrow-down" className="nudge-down cmwd-anim-nudge-down"/> : ""}
                </Panel.Heading>
                <Panel.Body>
                    <form>
                        <FormGroup
                            controlId="fileUploadForm">
                            <ControlLabel>Select files</ControlLabel>
                            <FormControl 
                                type="file"
                                multiple={true}
                                placeholder="Browse or drag and drop imahe into the box below"
                                onChange={this.handleFileUploadChange}
                            />
                        </FormGroup>
                    </form>
                </Panel.Body>
            </Panel>
        )
    }
}

export default LoadImages



// WEBPACK FOOTER //
// ./src/components/LoadImages.jsx